<div class="position-relative h-100 d-flex flex-column">
  <div class="scroll page-bg flex-fill overflow-auto py-3 px-5 centerform">
    <div class="container p-0">
      <form [formGroup]="curriculumForm" (ngSubmit)="onSubmit()">
        <div class="mControls">
          <div class="input-group mr-auto">
            <h1 class="m-0 text-white align-items-center d-inline-flex">Create New Yearly Plan</h1>
          </div>
          <div class="mControls__right">
            <div class="input-group">
              <button type="button" mat-raised-button (click)="navigateBack()">Cancel</button>
            </div>
            <div class="input-group">
              <button type="submit" mat-raised-button color="primary">Done</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mb-3">
            <div class="card">
              <div class="card-header">General</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Name</mat-label>
                      <input maxlength="255" placeholder="Yearly Plan Name" matInput type="text" formControlName="curriculum_name" required>
                      <mat-error *ngIf="curriculumForm.get('curriculum_name').hasError('required')">Name is required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Description</mat-label>
                      <textarea matInput rows="5" placeholder="Main description" formControlName="description"></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
